import { render, staticRenderFns } from "./SavedDayCard.vue?vue&type=template&id=2c29a258&scoped=true&"
import script from "./SavedDayCard.vue?vue&type=script&lang=js&"
export * from "./SavedDayCard.vue?vue&type=script&lang=js&"
import style0 from "./SavedDayCard.vue?vue&type=style&index=0&id=2c29a258&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c29a258",
  null
  
)

component.options.__file = "SavedDayCard.vue"
export default component.exports